import { CTLogo } from "@/src/assets/svgs/CTLOGO"
import { Button } from "@mui/material"
import { useTranslations } from "next-intl"

export const CTLoginButton = ({ onClick }: { onClick: () => void }) => {
    const t = useTranslations('otpModal')
    return (
        <Button
            sx={{
                height: 40,
                fontSize: 14,
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: '4px',
                backgroundColor: 'white',
                color: 'text.primary',
                border: '1px solid',
                borderColor: 'grey.300',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                '&:hover': {
                    backgroundColor: 'grey.50',
                    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)'
                }
            }}
            startIcon={<CTLogo />}
            fullWidth
            onClick={onClick}
        >
            {t('continueWithCleartrip')}
        </Button>
    )
}
